const ProductDetailsSkeleton: React.FC = () => {
  return (
    <section className="pt-8 pb-16 max-md:pb-6">
      <div className="container flex flex-col gap-4">
        <div className="text-start text-primary text-xl flex items-center gap-2">
          <div className="skeleton w-6 h-6 !rounded-md"></div>
          <div className="skeleton w-20 h-6 !rounded-md"></div>
        </div>
        <div className="grid grid-cols-3 max-lg:grid-cols-2 max-md:grid-cols-1 gap-4">
          <div className="group overflow-hidden rounded-xl h-[550px] inset-shadow max-lg:col-auto flex items-center relative justify-center custom-style-slider md:sticky top-2">
            <div className="h-[560px] w-full max-h-[inherit] object-cover absolute z-0 top-0 left-0 blur skeleton"></div>
          </div>
          <div className="col-span-2 max-lg:col-auto">
            <div className="flex gap-4 flex-col pb-5">
              <div className="flex items-center gap-3 text-base">
                {[1, 2, 3, 4, 5].map((item) => {
                  return (
                    <div
                      key={item}
                      className="flex gap-5 relative items-center justify-center mt-2"
                    >
                      <div className="h-5 w-5 skeleton !rounded-md"></div>
                    </div>
                  );
                })}
                <div className="h-5 w-28 ml-3 skeleton !rounded-md mt-2"></div>
              </div>
              <div className="h-8 w-64 mt-5 skeleton !rounded-md"></div>
              <div className="h-6 w-32 skeleton !rounded-md"></div>
            </div>
            <div className="flex items-center gap-4 text-5xl max-sm:text-2xl">
              <div className="h-10 w-44 skeleton !rounded-md"></div>
            </div>
            <div className="flex max-xl:flex-col gap-1 max-md:gap-5 justify-between">
              <div className="flex items-start justify-start gap-3 mt-5 w-2/4 overflow-hidden max-xl:w-full">
                <div className="h-6 w-28 skeleton mr-5 !rounded-md"></div>
                <div className="h-6 w-28 skeleton !rounded-md"></div>
              </div>
              <div className="flex max-sm:flex-wrap items-center justify-end gap-2 w-2/4 max-xl:w-full">
                <button className="skeleton w-[160px] max-sm:w-[90px] max-sm:h-10 h-14 !rounded-full inline-flex items-center gap-3   max-md:p-2 max-md:gap-2  py-3 px-6"></button>
                <button className="skeleton w-[180px] max-sm:w-[120px] max-sm:h-10 h-14 !rounded-full inline-flex items-center gap-3   max-md:p-2 max-md:gap-2  py-3 px-6 "></button>
              </div>
            </div>
            <div className="h-6 w-24 max-sm:mt-5 max-md:mt-2 max-lg:mt-4 mt-10 skeleton !rounded-md"></div>
            <div className="flex gap-3 flex-wrap mt-4">
              <div className="w-[100px] h-[120px] skeleton p-1"></div>
              <div className="w-[100px] h-[120px] skeleton p-1"></div>
            </div>
            <div className="relative grid max-lg:grid-cols-1 gap-4 items-center justify-between flex-wrap mt-4 grid-cols-2">
              <div className="flex items-center gap-5">
                <div className="h-7 w-16 skeleton !rounded-md"></div>
                <div className="relative mt-2">
                  <button className="skeleton min-w-[160px] h-14 !rounded-full inline-flex items-center gap-3 max-md:p-2 max-md:gap-2  py-3 px-6"></button>
                </div>
              </div>
              <div className="flex max-md:flex-wrap gap-3 items-center">
                <div className="inline-flex mt-0 max-md:justify-evenly max-sm:items-start max-sm:justify-start items-center text-xl gap-5 max-sm:flex-col max-md:p-2 max-md:gap-2 py-3 max-md:py-2 px-6 rounded-full">
                  <button className="skeleton min-w-[170px] max-sm:h-12 h-14 mt-2 !rounded-full inline-flex items-center gap-3 max-md:p-2 max-md:gap-2 py-3 px-6"></button>
                  <button className="skeleton w-[300px] !rounded-[5px_30px_18px_30px] h-16 mt-2 inline-flex items-center gap-3 p-2 py-3 px-6 max-lg:w-[160px] max-sm:w-[340px] max-lg:h-14 max-md:w-[250px] max-md:ml-10 max-sm:ml-0 max-md:gap-2 max-md:h-14 max-xl:w-[120px] max-2xl:w-[200px]"></button>
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <div className="border-b border-t mt-2 border-[#89D9EE] text-primary block py-5 w-full metrics-overflow">
                {[1, 2, 3, 4, 5].map((item) => {
                  return (
                    <div key={item}>
                      <div className="h-5 w-full skeleton !rounded-sm mb-2"></div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductDetailsSkeleton;
